import { c as create_ssr_component, v as validate_component, h as add_attribute } from "../../../../../chunks/index.js";
import { T as Topbar } from "../../../../../chunks/Topbar.js";
import { C as CardIcon } from "../../../../../chunks/CardIcon.js";
import { M as Map, a as Marker } from "../../../../../chunks/GeolocateControl.svelte_svelte_type_style_lang.js";
import { C as CardCTAContact } from "../../../../../chunks/CardCTAContact.js";
import "../../../../../chunks/index2.js";
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let mapComponent;
  let $$settled;
  let $$rendered;
  do {
    $$settled = true;
    $$rendered = `<section class="${"h-screen grid grid-cols-2"}"><div>${validate_component(Topbar, "Topbar").$$render(
      $$result,
      {
        light: true,
        class: "h-16 ml-24 w-[42%] fixed mt-10 grid auto-cols-min grid-cols-2 z-20"
      },
      {},
      {}
    )}
        <div class="${"h-full brightness-75"}">${validate_component(Map, "Map").$$render(
      $$result,
      {
        accessToken: "pk.eyJ1Ijoic2FtdWVsbXNzdHVkaW8iLCJhIjoiY2w1YjhmbjAxMDU1YzNkbDF0Y2x6NzNseiJ9.LLeTwdgDiFe_Bju9Q6ZiBw",
        customStylesheetUrl: "mapbox://styles/samuelmsstudio/cl5b9egy200b216p3lv53zirx",
        options: { scrollZoom: false },
        this: mapComponent
      },
      {
        this: ($$value) => {
          mapComponent = $$value;
          $$settled = false;
        }
      },
      {
        default: () => {
          return `${validate_component(Marker, "Marker").$$render(
            $$result,
            {
              lat: 46.19825864361418,
              lng: 6.059434533662986,
              color: "rgb(255,255,255)",
              label: "Venez nous rendre visite !",
              popupClassName: "class-name"
            },
            {},
            {}
          )}`;
        }
      }
    )}</div></div>
    <div class="${"grid grid-cols-6 grid-rows-3"}"><div class="${"col-span-4 bg-blue-600"}"><img class="${"w-full h-full object-cover aspect-video"}" src="${"/gva-it.jpg"}"></div>
        ${validate_component(CardIcon, "CardIcon").$$render(
      $$result,
      {
        class: "bg-blue-600 col-span-2",
        title: "Interventions",
        text: "Nous intervenons en Suisse Romande et France voisine",
        bgBackColor: "bg-blue-600",
        fadeDelay: 650
      },
      {},
      {
        default: () => {
          return `<div class="${"bottom text-white justify-self-end row-start-2 justify-self-end"}"><svg class="${"w-10 h-10"}" fill="${"none"}" stroke="${"currentColor"}" viewBox="${"0 0 24 24"}" xmlns="${"http://www.w3.org/2000/svg"}"><path d="${"M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"}"></path><path strokelinecap="${"round"}" strokelinejoin="${"round"}"${add_attribute("strokewidth", 2, 0)} d="${"M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"}"></path></svg></div>`;
        }
      }
    )}
        ${validate_component(CardIcon, "CardIcon").$$render(
      $$result,
      {
        class: "bg-blue-600 col-span-2",
        title: "Interventions",
        text: "Nous intervenons en Suisse Romande et France voisine",
        bgBackColor: "bg-blue-600",
        fadeDelay: 850
      },
      {},
      {
        default: () => {
          return `<div class="${"bottom text-white justify-self-end row-start-2 justify-self-end"}"><svg class="${"w-10 h-10"}" fill="${"none"}" stroke="${"currentColor"}" viewBox="${"0 0 24 24"}" xmlns="${"http://www.w3.org/2000/svg"}"><path d="${"M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"}"></path><path strokelinecap="${"round"}" strokelinejoin="${"round"}"${add_attribute("strokewidth", 2, 0)} d="${"M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"}"></path></svg></div>`;
        }
      }
    )}
        ${validate_component(CardCTAContact, "CardCTAContact").$$render($$result, {}, {}, {})}
        <div class="${"h-full w-full col-span-6 bg-gray-900 grid grid-rows-3 p-9"}"><p class="${"text-white text-md row-span-2 flex items-end self-center"}">GVA IT Services s\u2019est sp\xE9cialis\xE9e au cours des ann\xE9es dans l\u2019offre de services informatiques aux professionnels: TPE, PME/PMI mais aussi aupr\xE8s de grandes entreprises. La taille de la structure et la comp\xE9tence de ses \xE9quipes permettent \xE0 GVA IT Services d\u2019\xEAtre un interlocuteur extr\xEAmement flexible, r\xE9actif et parfaitement qualifi\xE9 pour offrir aux entreprises des solutions adapt\xE9es \xE0 leurs besoins tout en respectant leurs contraintes de budget.
            </p>
            <h1 class="${"h-full flex text-4xl text-white font-medium items-end justify-end border-t border-solid border-white border-opacity-30"}">\xC0 Propos
            </h1></div></div></section>`;
  } while (!$$settled);
  return $$rendered;
});
export {
  Page as default
};
